import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SharedModule } from '../../shared/shared.module'
import { WmsChartService } from 'wms-chart-loader';
import { NgsildConnectorService } from 'ngsild-connector';

@Component({
    selector: 'app-logout',
    imports: [SharedModule],
    templateUrl: './logout.component.html',
    styleUrl: './logout.component.scss'
})
export class LogoutComponent implements OnInit, OnDestroy {
  private redirectInterval: any; // Store timeout ID
  private readonly intervalTimer: number = 0;
  countdown = 0; // Countdown before redirect

  constructor(
      private readonly router: Router,
      private readonly wmsChartService: WmsChartService,
      private readonly ngsildConnectorService: NgsildConnectorService
  ) {}

  ngOnInit(): void {
    // Countdown effect
    this.redirectInterval = setInterval(() => {
      // this.countdown--;
      if (this.countdown === 0) {
        this.clearSession();

        this.router.navigate(['/login']); // Redirect after countdown
      }
    }, this.intervalTimer);

  }

  clearSession() {
    // Clear session storage, tokens, etc.
    sessionStorage.clear();
    // Only clear session-related data and keep user-defined settings in local storage 
    //localStorage.clear();
  }

  ngOnDestroy(): void {
    if (this.redirectInterval) {
      clearInterval(this.redirectInterval);
    }

    // workaround
    this.ngsildConnectorService.stop();
    this.wmsChartService.stop();
  }
}
